export default __webpack_public_path__ + "media/images/filter-0c6d50692f1dde31955ecb70f1f000b0.svg";